/**
 * User Master-specific translation keys
 */
module.exports = {
  list: {
    main_heading: "admin.user_list_main_heading",
    search_placeholder: "admin.user_search_placeholder",
    admin_status_option: "admin.user_admin_status_option",
    user_status_option: "admin.user_user_status_option", 
    signup_type_option: "admin.user_signup_type_option",
    clear_filter_btn_text: "admin.user_clear_filter_btn_text",
    download_btn_text: "admin.user_download_btn_text",
    delete_user_heading_text: "admin.user_delete_heading_text",
    delete_user_yes_text: "admin.user_delete_yes_text",
    delete_user_no_text: "admin.user_delete_no_text",
    update_popup_admin_heading_text: "admin.user_update_popup_admin_heading_text",
    update_popup_user_heading_text: "admin.user_update_popup_user_heading_text",
    user_activate_blocked_admin_inactive: "admin.user_activate_blocked_admin_inactive",
    update_popup_yes_btn_text: "admin.user_update_popup_yes_btn_text",
    update_popup_no_btn_text: "admin.user_update_popup_no_btn_text",
    signup_types: {
      normal: "admin.user_signup_type_normal",
      google: "admin.user_signup_type_google",
      apple: "admin.user_signup_type_apple"
    },
    defaults: {
      username: "admin.user_default_username",
      inactive_status: "admin.user_default_inactive_status",
      na: "admin.user_default_na"
    },
    table: {
      created_at_table_heading: "admin.user_created_at_table_heading",
      email_table_heading: "admin.user_email_table_heading",
      full_name_heading: "admin.user_full_name_table_heading",
      contact_number_heading: "admin.user_contact_number_table_heading",
      username_heading: "admin.user_username_table_heading",
      admin_status_heading: "admin.user_admin_status_table_heading",
      user_status_heading: "admin.user_user_status_table_heading",
      signup_type_heading: "admin.user_signup_type_table_heading",
      app_version_heading: "admin.user_app_version_table_heading",
      reason_heading: "admin.user_reason_table_heading",
      deleted_at_heading: "admin.user_deleted_at_table_heading",
      action_table_col_heading: "admin.user_action_table_col_heading",
      deactivate_reason: "admin.user_deactivate_reason",
      deactivate_reason_placeholder: "admin.user_deactivate_reason_placeholder",
      confirm_modal_text: "admin.user_confirm_modal_text",
      cancel_modal_text: "admin.user_cancel_modal_text",
      start_date_label: "admin.user_start_date_label",
      end_date_label: "admin.user_end_date_label",
      view_tooltip: "admin.user_view_tooltip",
      reward_count_heading: "admin.user_reward_count_table_heading"
    },
    premium_reward: {
      button_text: "admin.user_grant_premium_reward_btn_text",
      months_not_configured_message: "admin.user_grant_premium_reward_months_not_configured_message",
      confirm_heading: "admin.user_grant_premium_reward_confirm_heading",
      confirm_message: "admin.user_grant_premium_reward_confirm_message",
      confirm_yes_text: "admin.user_grant_premium_reward_confirm_yes_text",
      confirm_no_text: "admin.user_grant_premium_reward_confirm_no_text",
      success_message: "admin.user_grant_premium_reward_success_message"
    }
  },
  edit: {
    main_heading: "admin.user_edit_heading",
  },
  view: {
    main_heading: "admin.user_view_heading",
    back_to_list: "admin.user_view_back_to_list",
    user_details: "admin.user_view_user_details",
    defaults: {
      na: "admin.user_view_default_na",
      normal_signup: "admin.user_view_normal_signup"
    },
    tabs: {
      personal_info: "admin.user_view_tab_personal_info",
      profile_details: "admin.user_view_tab_profile_details", 
      education: "admin.user_view_tab_education",
      work_experience: "admin.user_view_tab_work_experience",
      interests_appearances: "admin.user_view_tab_interests_appearances"
    },
    personal_info: {
      title: "admin.user_view_personal_info_title",
      full_name: "admin.user_view_full_name",
      email: "admin.user_view_email",
      contact_number: "admin.user_view_contact_number",
      username: "admin.user_view_username",
      admin_status: "admin.user_view_admin_status",
      user_status: "admin.user_view_user_status",
      signup_type: "admin.user_view_signup_type",
      app_version: "admin.user_view_app_version",
      email_verified: "admin.user_view_email_verified",
      phone_verified: "admin.user_view_phone_verified",
      two_factor_sms_enabled: "admin.user_view_two_factor_sms_enabled",
      two_factor_email_enabled: "admin.user_view_two_factor_email_enabled",
      joined_date: "admin.user_view_joined_date",
      last_login: "admin.user_view_last_login",
      last_online: "admin.user_view_last_online",
      policy_accepted: "admin.user_view_policy_accepted",
      terms_accepted: "admin.user_view_terms_accepted"
    },
    profile_details: {
      title: "admin.user_view_profile_details_title",
      bio: "admin.user_view_bio",
      about_me: "admin.user_view_about_me",
      date_of_birth: "admin.user_view_date_of_birth",
      gender: "admin.user_view_gender",
      house_number: "admin.user_view_house_number",
      street: "admin.user_view_street",
      zip_code: "admin.user_view_zip_code",
      city: "admin.user_view_city",
      country: "admin.user_view_country",
      preferred_language: "admin.user_view_preferred_language",
      latitude: "admin.user_view_latitude",
      longitude: "admin.user_view_longitude",
      cover_photo: "admin.user_view_cover_photo",
      no_profile_info: "admin.user_view_no_profile_info"
    },
    education: {
      title: "admin.user_view_education_title",
      school: "admin.user_view_education_school",
      graduation_year: "admin.user_view_education_graduation_year",
      primary: "admin.user_view_education_primary",
      secondary: "admin.user_view_education_secondary",
      no_education_info: "admin.user_view_no_education_info"
    },
    work_experience: {
      title: "admin.user_view_work_experience_title",
      company: "admin.user_view_work_company",
      industry: "admin.user_view_work_industry",
      employment_type: "admin.user_view_work_employment_type",
      no_work_info: "admin.user_view_no_work_info"
    },
    interests_appearances: {
      interests_title: "admin.user_view_interests_title",
      appearances_title: "admin.user_view_appearances_title",
      no_interests: "admin.user_view_no_interests",
      no_appearances: "admin.user_view_no_appearances"
    },
    status_badges: {
      admin: "admin.user_view_admin_badge",
      user: "admin.user_view_user_badge",
      active: "admin.user_view_status_active",
      inactive: "admin.user_view_status_inactive",
      deleted: "admin.user_view_status_deleted"
    },
    error: {
      user_not_found: "admin.user_view_error_user_not_found",
      user_not_found_description: "admin.user_view_error_user_not_found_description",
      back_to_user_list: "admin.user_view_error_back_to_list"
    }
  }
};
